import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  background: ${props => props.theme.colors.transparent};
  min-height: ${props => (props.isSortable ? '50px' : '26px')};
  line-height: 2;
  font-family: ${props => props.theme.fontSets.narrow};
  position: relative;
  border-bottom: 5px solid ${props => props.theme.colors.mainColorDark};
  margin-bottom: 20px;
`;



// WEBPACK FOOTER //
// ./src/components/DynamicTable/TableHeader/styles.js